"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _underscore = require("../utils/underscore");

var _UIBadge = _interopRequireDefault(require("./UIBadge"));

var _devWarnings = require("../utils/devWarnings");

var BADGE_SIZE = {
  default: 'count',
  md: 'count',
  sm: 'dot'
};
var popIn = (0, _styledComponents.keyframes)(["0%{animation-timing-function:cubic-bezier(.16,.84,.44,1);transform:scale(1);}50%{animation-timing-function:cubic-bezier(.89,.03,.68,.22);transform:scale(1.25);}100%{transform:scale(1);}"]);
var scaleIn = (0, _styledComponents.keyframes)(["0%{transform:scale(.75);}100%{transform:scale(1);}"]);
var fadeIn = (0, _styledComponents.keyframes)(["0%{opacity:0;}33%{opacity:1;}"]);
var scaleOut = (0, _styledComponents.keyframes)(["0%{transform:scale(1);}75%{transform:scale(.75);}"]);
var fadeOut = (0, _styledComponents.keyframes)(["0%,25%{opacity:1;}100%{opacity:0;}"]);

var NotificationBadgeTransitionWrapper = _styledComponents.default.div.withConfig({
  displayName: "UINotificationBadge__NotificationBadgeTransitionWrapper",
  componentId: "hrj8c8-0"
})([".private-notification__badge{", ";opacity:", ";}"], function (_ref) {
  var firstRender = _ref.firstRender,
      open = _ref.open,
      transitionActive = _ref.transitionActive;
  if (!transitionActive) return '';
  if (firstRender && open) return (0, _styledComponents.css)(["animation:", " 150ms;"], popIn);
  return open ? (0, _styledComponents.css)(["animation:", " 300ms cubic-bezier(0.2,0.9,0.3,2),", " 150ms cubic-bezier(0.42,0,0.58,1);"], scaleIn, fadeIn) : (0, _styledComponents.css)(["animation:", " 150ms cubic-bezier(0.89,0.03,0.68,0.22),", " 200ms cubic-bezier(0.42,0,0.58,1);"], scaleOut, fadeOut);
}, function (_ref2) {
  var open = _ref2.open;
  return open ? 1 : 0;
});

var getTransitionDuration = function getTransitionDuration(firstRender, open) {
  if (firstRender && open) return 150;
  return open ? 300 : 200;
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UINotificationBadge__Wrapper",
  componentId: "hrj8c8-1"
})(["position:relative;display:inline-flex;align-items:baseline;line-height:1;"]);

var insetBadgeMixin = (0, _styledComponents.css)(["position:absolute;left:75%;top:5%;"]);

var getOutsetBadgeOffset = function getOutsetBadgeOffset(_ref3) {
  var use = _ref3.use;
  return use === 'dot' ? '-5px' : '-10.5px';
};

var outsetBadgeMixin = (0, _styledComponents.css)(["position:absolute;right:", ";top:", ";"], getOutsetBadgeOffset, getOutsetBadgeOffset);
var Badge = (0, _styledComponents.default)(function (_ref4) {
  var __placement = _ref4.placement,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["placement"]);
  return _react.default.createElement(_UIBadge.default, rest);
}).withConfig({
  displayName: "UINotificationBadge__Badge",
  componentId: "hrj8c8-2"
})(["", ";"], function (_ref5) {
  var placement = _ref5.placement;
  if (placement === 'inset') return insetBadgeMixin;
  if (placement === 'outset') return outsetBadgeMixin;
  return null;
});

var UINotificationBadge = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UINotificationBadge, _Component);

  function UINotificationBadge(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UINotificationBadge);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UINotificationBadge).call(this, props));
    _this._descriptionId = (0, _underscore.uniqueId)('notification-badge-');
    _this._hasRendered = false;
    return _this;
  }

  (0, _createClass2.default)(UINotificationBadge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._hasRendered = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          badgeClassName = _this$props.badgeClassName,
          badgeDescription = _this$props.badgeDescription,
          badgeLabel = _this$props.badgeLabel,
          children = _this$props.children,
          className = _this$props.className,
          placement = _this$props.placement,
          showBadge = _this$props.showBadge,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["badgeClassName", "badgeDescription", "badgeLabel", "children", "className", "placement", "showBadge", "size"]);
      var firstRender = !this._hasRendered;
      (0, _devWarnings.warnIfFragment)(children, UINotificationBadge.displayName);
      return _react.default.createElement(Wrapper, Object.assign({}, rest, {
        className: (0, _classnames.default)('private-notification__wrapper', className)
      }), (0, _react.cloneElement)(children, {
        'aria-describedby': showBadge ? this._descriptionId : undefined
      }), _react.default.createElement(_TwoWayTransition.default, {
        duration: getTransitionDuration(firstRender, showBadge),
        firstRender: firstRender,
        transitionOnMount: true,
        Wrapper: NotificationBadgeTransitionWrapper
      }, showBadge && _react.default.createElement(Badge, {
        className: (0, _classnames.default)('private-notification__badge', badgeClassName),
        id: this._descriptionId,
        placement: placement,
        use: BADGE_SIZE[(0, _tshirtSize.toShorthandSize)(size)]
      }, badgeLabel, _react.default.createElement("span", {
        className: "sr-only"
      }, badgeDescription))));
    }
  }]);
  return UINotificationBadge;
}(_react.Component);

exports.default = UINotificationBadge;
UINotificationBadge.propTypes = {
  badgeClassName: _propTypes.default.string,
  badgeDescription: _propTypes.default.string.isRequired,
  badgeLabel: _propTypes.default.node,
  children: _propTypes.default.node,
  placement: _propTypes.default.oneOf(['inset', 'outset', 'inline']),
  size: (0, _tshirtSize.propTypeForSizes)(['sm', 'md'], ['default']),
  showBadge: _propTypes.default.bool
};
UINotificationBadge.defaultProps = {
  placement: 'outset',
  size: 'md',
  showBadge: true
};
UINotificationBadge.displayName = 'UINotificationBadge';
module.exports = exports.default;